import { makeStyles } from '@mui/styles';
import React,{ useEffect, useState } from 'react';
import * as _ from 'lodash';
import { fetchFloatingBanner } from '../../../network/agentProfileCrud';
import { AgentProfileItem } from '../../../types/agent-profile-types';
import { useParams } from 'react-router-dom';
import {
  EventModule,
  EventFeature,
} from "../../../../../utils/event-tracking/event-tracking.model";


type FloatingBannerProps = {
  agentProfile: AgentProfileItem;
  getBannerHight: (hight: number) => void;
  module: EventModule;
  feature: EventFeature;
};

 const FloatingBanner = (props: FloatingBannerProps) => {
  const { refId } = useParams<{ refId: string }>();
  const classes = useStyles();
  const isGIActive = _.get(props.agentProfile, 'agentDetail.license.gi', '') === 'Y';
  const [floatingBanner, setFloatingBanner] = useState<any>(null);
  useEffect(() => {
    if (refId) {
      fetchFloatingBanner(refId)
        .then((resp) => {
          setFloatingBanner(resp?.data[0])
          if((isGIActive && resp?.data[0] != undefined)) {
            props.getBannerHight(100)
          }else {
            props.getBannerHight(0)
          }
        })
        .catch(() => {});
    }
  }, [refId]);

  const clickBannerTrackingData = {
    target: "prueshop-banner",
    name: props.module == EventModule.dnc ? "anonymous::click-prueshop-banner" : "prospect::click-prueshop-banner",
    module: props.module,
    feature: props.feature,
    journey: "third-party-promotion",
  };
  return <> {isGIActive && floatingBanner && (
      <div className={classes.floatingBanner}>
        <div className={classes.floatingBannerInner}>
          <a href={floatingBanner?.targetUrl} target="_blank" rel="noreferrer">
              <img
                className={`auto_click_tracking ${classes.promotionBannerImg}`}
                data-auto_click_tracking={JSON.stringify(clickBannerTrackingData)}
                src={floatingBanner?.imageUrl}
                alt="Promotion"
              />
          </a>
        </div>
      </div>
  )}</>;
};

export default FloatingBanner;

const useStyles = makeStyles(() => ({
  floatingBanner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 8,
    backgroundColor: '#ffffff',
    display: 'flex',
    justifyContent: 'center',
  },
  floatingBannerInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    boxShadow: '0px 4px 16px 0px #00000014',
  },
  promotionBannerImg: {
    maxHeight: 100,
    width: '100%',
  },
}));
